import { defaultListData, defaultListState } from 'bv-data'
import type { ListModel, ListModelState } from '@/types'
import type { IGetUnconfirmed } from '@/services/batchProcessing/googleBatch'
import { getList, getUnconfirmed } from '@/services/batchProcessing/googleBatch'
import { getQuery } from 'bv-utils'
import { putSave } from '@/models/utils'
import type { GoogleBatchType, IGoogleBatchInfo } from '@/types/batch/google'

export type GoogleBatchModelState =
  ListModelState<IGoogleBatchInfo>
  & {
  id: number,
  counts: any,
  type: GoogleBatchType | '',
  invite: any
};
export type GoogleBatchListModel = ListModel<GoogleBatchModelState, 'googleBatch'>

export const namespace = 'googleBatch'

const listState: GoogleBatchModelState = {
  ...defaultListState,
  id: 0,
  type: '',
  counts: { recharge: null, rename: null, permission: null, invite: null, transfer: null },
  invite: {
    acceptCount: null,
    rejectCount: null,
    removeCount: null,
  },
}

const getCounts = (params: IGetUnconfirmed) => {
  const {
    unconfirmedSpend,
    unconfirmedRename,
    unconfirmedMccLink,
    unconfirmedMccTrans,
    unconfirmedUserRole,
  } = params || {}
  return {
    recharge: unconfirmedSpend,
    rename: unconfirmedRename,
    permission: unconfirmedUserRole,
    invite: unconfirmedMccLink,
    transfer: unconfirmedMccTrans,
  }
}

const BatchModel: GoogleBatchListModel = {
  namespace,
  state: listState,
  // effects: {
  //   * list ({ params }, { call, put, select }) {
  //     const id = yield select((state: any) => state.googleBatch.id)
  //     const requestId = id + 1
  //     yield put(putSave({ id: requestId, type: params, loading: true }))
  //     const [ data, error ] = yield call(getList, getQuery(), params)
  //     const [ counts ] = yield call(getUnconfirmed)
  //     const currentId = yield select((state: any) => state.googleBatch.id)
  //     if (currentId === requestId) {
  //       yield put(putSave({
  //         error, data: data ?? defaultListData,
  //         counts: getCounts(counts),
  //         loading: false,
  //         invite: {
  //           acceptCount: data?.acceptCount,
  //           rejectCount: data?.rejectCount,
  //           removeCount: data?.removeCount,
  //         },
  //       }))
  //     }
  //   },
  // },
  effects: {
    * list ({ params }, { call, put, select }) {
      const id: number = yield select((state: any) => state.googleBatch.id)
      const requestId = id + 1
      yield put(putSave({ id: requestId, type: params, loading: true }))
      const [ data, error ] = yield call(getList, getQuery(), params)

      const currentId: number = yield select((state: any) => state.googleBatch.id)
      if (currentId === requestId) {
        yield put(putSave({
          error, data: data ?? defaultListData,
          loading: false,
          invite: {
            acceptCount: data?.acceptCount,
            rejectCount: data?.rejectCount,
            removeCount: data?.removeCount,
          },
        }))
      }

      const [ counts ] = yield call(getUnconfirmed)
      if (currentId === requestId) {
        yield put(putSave({
          counts: getCounts(counts),
        }))
      }
    },
  },
  
  reducers: {
    clean (state) {
      return { ...state, ...defaultListState }
    },
    reset () {
      return listState
    },
    save (state, { payload = {} }) {
      return { ...state, ...payload }
    },
  },
}

export default BatchModel
